import React from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import LightBox from '@bd/bdui-lightbox';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { grid, colors } from '../styles';

export const styles = css`
  display: block;
  .PhotoList_wrapper {
    ${grid.makeContainer()}
  }
  .PhotoList_inner {
    display: flex;
    width: 100%:
    flex-wrap: wrap;
    flex-direction: column;
  }
  .PhotoList_heading {
    width: 100%;
    flex-shrink: 0;
    color: ${colors.body};
    font-size: 42px;
    font-weight: 300;
    line-height: 52px;
    padding: 0 0 60px 0;
    position: relative;
    text-align: center;
    &:after {
      content: '';
      height: 3px;
      width: 125px;
      background-color: ${colors.brand1};
      position: absolute;
      display: block;
      margin: 15px 0 0 -62px;
      left: 50%;

    }
  }
  .PhotoList_list {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    flex-flow: row wrap;
    justify-content: center;

    .PhotoList_item {
      list-style: none;
      margin: 0;
      padding: 0;
      cursor: pointer;
      border: 3px solid ${colors.white};
      width: 100%;
      span {
        position: relative;
        display: block;
      }
      .PhotoList_imageTitle {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        padding: 45% 10px 0 10px;
        width: 100%;
        z-index: 1;
        text-align: center;
        opacity: 0;
        transition: all .5s ease;
        background-color: rgba(232,241,245,.75);
        font-weight: 300;
        font-size: 16px;
        line-height: 1.2;
        color: ${colors.brand1};
        z-index: 2;
        &:hover {
          opacity: 1;
        }
        &:after {
          content:'';
          width: 26px;
          height: 26px;
          background-image: url('/images/icon-plus.svg');
          position: absolute;
          display: block;
          top: calc(50% - 26px);
          left: 50%;
          margin-left: -13px;
        }
      }
      .PhotoList_image {
        position: relative;
        z-index: 0;
        width: 100%;
        padding-top: 75%;
        background-size: cover;
        background-position: center center;
        z-index: 1;
      }
    }
  }
`;

export class PhotoListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showing: props.show,
      gallery: props.gallery,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.gallery !== this.props.gallery) {
      this.setState({
        showing: this.props.show,
      });
    }
  }

  showMore = () => {
    const { showing } = this.state;
    const { show } = this.props;
    this.setState({
      showing: showing + show,
    });
  }

  render() {
    const { heading, photos } = this.props;
    const { showing } = this.state;
    const photosSliced = showing > 0 ? photos.slice(0, showing) : photos;
    return (
      <div className={styles}>
        <div className="PhotoList_wrapper">
          <div className="PhotoList_inner">
            {
              heading &&
              <div className="PhotoList_heading">
                { heading }
              </div>
            }
            <LightBox
              items={photos}
              enableZoom
            >
              <ul className="PhotoList_list">
                {
                  uniqBy(photosSliced, 'contentUrl').map((photo, index) => {
                    return (
                      <li className="PhotoList_item col-6 col-lg-4" key={photo.contentUrl} data-index={index}>
                        <span data-index={index}>
                          {
                            photo.caption &&
                            <div className="PhotoList_imageTitle" data-index={index}>
                              {photo.caption}
                            </div>
                          }
                          {
                            photo &&
                            <div className="PhotoList_image" style={{ backgroundImage: `url('${buildThumbnailUrl(photo.contentUrl, { width: 600, height: 600 })}')` }} data-index={index} />
                          }
                        </span>
                      </li>
                    );
                  })
                }
              </ul>
            </LightBox>
            {
              showing < photos.length &&
              <div className="d-flex justify-content-center">
                <button
                  className="btn"
                  onClick={this.showMore}
                >
                  Load More
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

PhotoListComponent.propTypes = {
  heading: PropTypes.string,
  gallery: PropTypes.string,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      contentUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
  show: PropTypes.number,
};

PhotoListComponent.defaultProps = {
  heading: undefined,
  gallery: undefined,
  photos: [],
  show: 8,
};

export default PhotoListComponent;



// WEBPACK FOOTER //
// ./src/components/LightBoxPhotoList.js